module.exports = __webpack_public_path__ + "static/media/information.30b755d0.svg";